import {
  FETCH_FOOTPRINTS,
  SHOW_FOOTPRINTS_SEARCH,
  HIDE_FOOTPRINTS_SEARCH,
  HIDE_FOOTPRINTS,
  SHOW_FOOTPRINTS,
  UPDATE_FOOTPRINTS,
  CHANGE_FORM,
  FETCH_SUGGESTIONS,
  CREATE_FOOTPRINTS
} from './constants'

export const fetchFootprints = {
  request: (id) => ({ type: FETCH_FOOTPRINTS.REQUEST, id }),
  success: (footprints) => ({ type: FETCH_FOOTPRINTS.SUCCESS, footprints }),
  failure: (error) => ({ type: FETCH_FOOTPRINTS.FAILURE, error })
}

export const updateFootprints = {
  request: (id, data) => ({ type: UPDATE_FOOTPRINTS.REQUEST, id, data }),
  success: (data) => ({ type: UPDATE_FOOTPRINTS.SUCCESS, data }),
  failure: (error) => ({ type: UPDATE_FOOTPRINTS.FAILURE, error })
}

export const fetchSuggestions = {
  request: () => ({ type: FETCH_SUGGESTIONS.REQUEST }),
  success: (suggestions) => ({ type: FETCH_SUGGESTIONS.SUCCESS, suggestions })
}

export const createFootprints = {
  request: (clientId) => ({ type: CREATE_FOOTPRINTS.REQUEST, clientId }),
  success: () => ({ type: CREATE_FOOTPRINTS.SUCCESS }),
  failure: (error) => ({ type: CREATE_FOOTPRINTS.FAILURE, error })
}

export const showSearch = () => ({ type: SHOW_FOOTPRINTS_SEARCH })
export const hideSearch = () => ({ type: HIDE_FOOTPRINTS_SEARCH })
export const hideFootprints = () => ({ type: HIDE_FOOTPRINTS })
export const showFootprints = () => ({ type: SHOW_FOOTPRINTS })
export const changeForm = (data) => ({ type: CHANGE_FORM, data })
